import React from 'react';
import './styles/global.css';

import Routes from './routes';
import 'leaflet/dist/leaflet.css';


function App() {
  return (
    <Routes />
  );
}

export default App;
